let lastTheme = null;
let clearTheme;
let setTheme;
let loadTheme;

if (process.env.NODE_ENV === 'development') {
	clearTheme = () => lastTheme && lastTheme.unuse();

	setTheme = theme => {
		theme.use();
		lastTheme = theme;
	};

	loadTheme = themeName => new Promise(resolve => {
		import(`../style/${themeName}.styl`).then(theme => {
			setTheme(theme);
			resolve();
		});
	});
} else {
	clearTheme = () => lastTheme && lastTheme.remove();

	setTheme = theme => {
		lastTheme = theme;
	};

	loadTheme = themeName => new Promise(resolve => {
		const themeUrl = `/static/css/${themeName}.css`;
		const $linkEl = $(`<link href="${themeUrl}" rel="stylesheet">`);
		$('header').append($linkEl);
		setTheme($linkEl);
		$linkEl.on('load', () => resolve());
	});
}

export const loadContextTheme = loadTheme;
export const clearContextTheme = clearTheme;
